import {createSelector} from 'reselect';
import {initialState as initRootState} from './reducer';

const selectRootDomain = state => state.app || initRootState;

const selectRootOverlayState = () =>
    createSelector(
        selectRootDomain,
        state => state.overlay,
    );
const selectRootOverlayNameState = () =>
    createSelector(
        selectRootDomain,
        state => state.overlayName,
    );

export {
    selectRootDomain,
    selectRootOverlayState,
    selectRootOverlayNameState,
};
